// extracted by mini-css-extract-plugin
export default {"info":"MoreInfo_info__OkMRp","title":"MoreInfo_title__hV6um","text":"MoreInfo_text__12qlH","more":"MoreInfo_more__kvz66"};